import { render } from "./app-footer.vue?vue&type=template&id=6441ecd0"
const script = {}

import "./app-footer.vue?vue&type=style&index=0&id=6441ecd0&lang=css"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__